import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/api";

const STORAGE_VID = "idcardgen_visitor_id";
const SESSION_SID = "idcardgen_session_id";

function uuid() {
    if (typeof crypto !== "undefined" && crypto.randomUUID) {
        return crypto.randomUUID();
    }
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

function getVisitorId() {
    try {
        let v = localStorage.getItem(STORAGE_VID);
        if (!v) {
            v = uuid();
            localStorage.setItem(STORAGE_VID, v);
        }
        return v;
    } catch {
        return uuid();
    }
}

function getSessionId() {
    try {
        let s = sessionStorage.getItem(SESSION_SID);
        if (!s) {
            s = uuid();
            sessionStorage.setItem(SESSION_SID, s);
        }
        return s;
    } catch {
        return uuid();
    }
}

/**
 * Fires a /api/visits POST every time the route changes.
 * - Skips admin & studio routes (no need to track internal app pages).
 * - Dedupes same path within 30s on the server.
 */
export default function useVisitorTracking() {
    const loc = useLocation();
    const lastSent = useRef(null);

    useEffect(() => {
        const path = loc.pathname + (loc.search || "");

        // Skip private app surfaces
        if (
            path.startsWith("/admin") ||
            path.startsWith("/studio/") ||
            path === lastSent.current
        ) {
            return;
        }
        lastSent.current = path;

        const params = new URLSearchParams(loc.search || "");

        api.post("/visits", {
            visitor_id: getVisitorId(),
            session_id: getSessionId(),
            path,
            referrer:
                typeof document !== "undefined" ? document.referrer || "" : "",
            utm_source: params.get("utm_source") || null,
            utm_medium: params.get("utm_medium") || null,
            utm_campaign: params.get("utm_campaign") || null,
        }).catch(() => {
            /* swallow – tracking is best-effort */
        });
    }, [loc.pathname, loc.search]);
}
